import React, { Component } from 'react';
import { withDomains, RESTExecutor } from '../../../lib/domain';
import { showErrorInNotification, NetworkDelaySearch, showSuccessInNotification, formatMoney } from '../../../lib/util';
import { Spin, Input, Modal, Button, message, Typography, Row, Col, Empty, Popconfirm, Pagination, Tag, AutoComplete } from 'antd';
import ErrorWrapper from '../../../lib/error_wrapper';
import { BasicHeader } from '../../../components/basic_header';
import { TransparentButton } from '../../../components/basic_items';
import { Link } from 'react-router-dom';
import { StorageOutlined, FlipOutlined, AddOutlined, DeleteForever, Label } from '@material-ui/icons';

import lodash from 'lodash';
import { COLORS } from '../../theme';
import NetworkSelect from '../../../lib/ui/network_select';
import { JsonEditor as Editor } from 'jsoneditor-react';
import 'jsoneditor-react/es/editor.min.css';

import ace from 'brace';
import 'brace/mode/json';
import 'brace/theme/tomorrow_night_blue';

const queryString = require('query-string');

class GroupSourceList extends Component {
    constructor(props) {
        super(props)


        this.group_id = props.match.params.group_id;
        this.state = {
            filter_query: {},
            loading: true,
            group_obj: {},
            edit_id: null,
            form_data: {
                name: null,
                data_type_labels: [],
                extra_info: {},
                labels: []
            },
            form_visibility: false,
            datatype_objects: {}
        }

        this.detail_group = RESTExecutor.detail().config({
            label: 'detail'
        }).callbacks((success) => {
            this.setState({ group_obj: success.result })
            this.list_datatype.config({
                params: {
                    group_id: this.group_id,
                    pagination: false
                }
            }).execute();

            // this.list_sourcegroup.config({
            //     params: {
            //         ...this.state.filter_query,
            //         group_id: this.group_id
            //     }
            // }).execute()

        }, (error) => {
            this.setState({ loading: false })
        }).connect(props.domains.groups);

        this.list_sourcegroup = RESTExecutor
            .list()
            .config({
                label: 'sourcegroup_list',
            }).callbacks((success) => {

            }, (error) => {
                showErrorInNotification(error);
            })
            .connect(props.domains.groups);


        this.post_sourcegroup = RESTExecutor
            .post()
            .config({
                label: 'sourcegroup_list',
            }).callbacks((success) => {
                showSuccessInNotification(success, "Source Created")
                message.success("Source Mapping Updated", 3);
                this.setState({
                    form_data: {
                        name: null,
                        data_type_labels: [],
                        extra_info: {},
                        labels: []
                    },
                    form_visibility: false,
                    edit_id: null
                })

                this.list_sourcegroup.execute();
            }, (error) => {
                showErrorInNotification(error);
            })
            .connect(props.domains.groups);


        this.patch_sourcegroup = RESTExecutor
            .patch()
            .config({
                label: 'sourcegroup_detail',
            }).callbacks((success) => {
                showSuccessInNotification(success, "Source Updated")
                this.setState({
                    form_data: {
                        name: null,
                        data_type_labels: [],
                        extra_info: {},
                        labels: []
                    },
                    form_visibility: false,
                    edit_id: null
                })

                this.list_sourcegroup.execute();
            }, (error) => {
                showErrorInNotification(error);
            })
            .connect(props.domains.groups);
        this.delete_sourcegroup = RESTExecutor
            .delete()
            .config({
                label: 'sourcegroup_detail',
            }).callbacks((success) => {
                message.success("Source Deleted", 3);
                this.list_sourcegroup.execute();
            }, (error) => {
                showErrorInNotification(error);
            })
            .connect(props.domains.groups);


        this.list_datatype = RESTExecutor
            .list()
            .config({
                label: 'data_types',
            }).callbacks((success) => {
                // create form for source add
                let list = success.result.rows || [];
                let dt_obj = lodash.keyBy(list, 'id');
                this.setState({ datatype_objects: dt_obj, loading: false });
                this.list_sourcegroup.config({
                    params: {
                        ...this.state.filter_query,
                        group_id: this.group_id
                    }
                }).execute();

            }, (error) => {
                showErrorInNotification(error);
                this.setState({ loading: false })
            })
            .connect(props.domains.datatype);


        this.delay_search = new NetworkDelaySearch();


    }

    stateUpdater = ({
        stateKey,
        valueKey,
        value,
        appendObj = {},
        callback
    }) => {
        let newData = this.state[stateKey];
        this.has_changed = true;
        if (valueKey) {
            newData[valueKey] = value;
        }
        if (appendObj) {
            Object.assign(newData, appendObj)
        }
        console.log(newData);
        this.setState({
            [stateKey]: newData
        }, () => {
            typeof callback === 'function' && callback()
        })
    }

    render() {
        const { loading, filter_query, group_obj, form_data, datatype_objects, edit_id } = this.state;
        if (loading) {
            return <center><Spin /></center>
        }

        let resp_card = { xs: 24, sm: 24, md: 12, lg: 8, xl: 8 }

        let detail_group_resp = this.detail_group.response();
        let list_sourcegroup_resp = this.list_sourcegroup.response();
        let list_datatype_resp = this.list_datatype.response();
        let post_sourcegroup_resp = this.post_sourcegroup.response();
        let patch_sourcegroup_resp = this.patch_sourcegroup.response();

        let delete_sourcegroup_resp = this.delete_sourcegroup.response()

        let rowsData = (list_sourcegroup_resp.result && list_sourcegroup_resp.result.rows) || [];
        let rowsMeta = list_sourcegroup_resp.meta || {};


        return (
            <div>

                <ErrorWrapper error={detail_group_resp}
                    onReload={() => {
                        this.setState({ loading: true })
                        this.detail_group.forId(this.group_id).execute()
                    }}
                >
                    <BasicHeader
                        title={group_obj.name}
                        titleType="Group"
                        subtitle="Sources"

                        right={[
                            <TransparentButton
                                label="Add New"
                                className='cta-primary'
                                hint="Add New Source"
                                onClick={() => {
                                    let data_type_labels = Object.keys(datatype_objects).map((key) => {
                                        return {
                                            "data_type_id": key, "label": null
                                        }
                                    });
                                    this.setState({
                                        edit_id: null,
                                        form_data: {
                                            name: null,
                                            data_type_labels: data_type_labels,
                                            extra_info: {},
                                            labels: []
                                        },
                                        form_visibility: true
                                    })
                                }}

                            />,
                            <Link to={`/settings/groups/${this.group_id}/datatype`} >
                                <TransparentButton
                                    label="Datatypes"
                                    icon={<StorageOutlined />}
                                    hint="View Datatypes"
                                />
                            </Link>,
                            <Link to={`/settings/groups/${this.group_id}/reconcilers`} >
                                <TransparentButton
                                    label="Reconcilers"
                                    icon={<FlipOutlined />}
                                    hint="View Reconcilers"
                                />
                            </Link>,
                            <Link to={`/settings/groups/${this.group_id}/labels`} >
                                <TransparentButton
                                    label="Labels"
                                    icon={<Label />}
                                    hint="View Labels"
                                />
                            </Link>
                            // <TransparentButton
                            //     label="Export"
                            //     hint="Export Selected Datatype"
                            //     disabled={selected_ids.length == 0}
                            //     onClick={() => {
                            //         this.export_data.execute({
                            //             data_types: this.state.all_selected ? true : selected_ids
                            //         });
                            //     }}

                            // />
                        ]}

                    />

                    <ErrorWrapper error={list_datatype_resp}
                        onReload={() => {
                            this.setState({ loading: true })
                            this.list_datatype.config({
                                params: {
                                    group_id: this.group_id,
                                    pagination: false
                                }
                            }).execute();
                        }}
                    >
                        <div className='filter-card'>
                            <div style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                flexWrap: 'nowrap',
                                paddingTop: 4, paddingBottom: 12
                            }}>
                                <Input.Search
                                    placeholder="Search For"
                                    style={{
                                    }}
                                    allowClear
                                    autoFocus
                                    value={filter_query.query}
                                    onChange={(e) => {
                                        this.stateUpdater({
                                            stateKey: 'filter_query', valueKey: 'query', value: e.target.value,
                                            callback: () => {
                                                this.delay_search.onSearch(() => {
                                                    this.props.history.push({
                                                        search: queryString.stringify({ ...this.state.filter_query, per_page: 100, page: 1 })
                                                    })
                                                })
                                            }
                                        })
                                    }}
                                />
                            </div>
                        </div>

                        <ErrorWrapper
                            error={list_sourcegroup_resp}
                            onReload={() => {
                                this.list_sourcegroup.execute()
                            }}
                        >

                            <Modal
                                centered
                                dimmer='blurring'

                                width={'80%'}
                                // size='small'
                                visible={this.state.form_visibility}
                                destroyOnClose
                                onCancel={() => {
                                    this.setState({
                                        form_data: {
                                            name: null,
                                            data_type_labels: [],
                                            extra_info: {},
                                            labels: []
                                        },
                                        form_visibility: false
                                    })
                                }}
                                footer={[
                                    <Button key='cancel' type='danger'
                                        disabled={post_sourcegroup_resp.fetching || patch_sourcegroup_resp.fetching}
                                        onClick={() => {
                                            this.setState({
                                                form_data: {
                                                    name: null,
                                                    data_type_labels: [],
                                                    extra_info: {},
                                                    labels: []
                                                },
                                                form_visibility: false
                                            })
                                        }}>
                                        Cancel
                                    </Button>,
                                    <Button key='submit' type='primary'
                                        disabled={post_sourcegroup_resp.fetching || patch_sourcegroup_resp.fetching}
                                        loading={post_sourcegroup_resp.fetching || patch_sourcegroup_resp.fetching}
                                        onClick={() => {
                                            edit_id != null ?
                                                this.patch_sourcegroup.forId(edit_id).execute({
                                                    ...this.state.form_data,
                                                    group_id: this.group_id
                                                }) :
                                                this.post_sourcegroup.execute({
                                                    ...this.state.form_data,
                                                    group_id: this.group_id
                                                });
                                        }}>
                                        Submit
                                    </Button>

                                ]}
                            >
                                <Typography.Title style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center'
                                }} level={2} ><AddOutlined /> &nbsp; {`${this.state.edit_id ? "Edit" : "Add"} Source`}</Typography.Title>

                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column'
                                }}>
                                    <span className='input-label' style={{
                                        color: '#000'
                                    }}>Name</span>
                                    <Input placeholder="Source Name"
                                        value={form_data.name}
                                        onChange={(e) => {
                                            this.stateUpdater({
                                                stateKey: 'form_data',
                                                value: e.target.value,
                                                valueKey: 'name'
                                            })
                                        }}
                                        style={{
                                            marginBottom: 16
                                        }}
                                    >
                                    </Input>
                                    <span className='input-label' style={{
                                        color: '#000'
                                    }}>Labels</span>

                                    <NetworkSelect
                                        value={form_data.labels}
                                        style={{ marginBottom: 26 }}
                                        item={{ name: "Labels", display_key: 'label', item_key: "id", mode: 'multiple' }}
                                        url={`/group-source-labels?group_id=${this.group_id}`}
                                        onChange={(received_value) => {
                                            this.stateUpdater({
                                                stateKey: 'form_data',
                                                value: received_value,
                                                valueKey: 'labels'
                                            })
                                            // this._change(item.index, received_value, d_key)
                                        }}
                                    // renderItem={(data)=>{
                                    //     // console.log("data",data)
                                    //     let ref = data.__references__ || {};
                                    //     let source = ref.source_id || {};
                                    //     return source.name
                                    //   }}

                                    />
                                    {/* <Input placeholder="Labels"
                                        value={form_data.labels}
                                        onChange={(e) => {
                                            this.stateUpdater({
                                                stateKey: 'form_data',
                                                value: e.target.value,
                                                valueKey: 'name'
                                            })
                                        }}
                                        style={{
                                            marginBottom: 26
                                        }}
                                    >
                                    </Input> */}
                                    <span className='input-label' style={{
                                        color: '#000',
                                        marginBottom: 15
                                    }}>Sources</span>
                                    {form_data.data_type_labels.map((item, item_index) => {
                                        return <div style={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            flexWrap: 'nowrap',
                                            paddingTop: 5,
                                            paddingBottom: 5,
                                            alignItems: 'center'
                                        }}>
                                            <div style={{ flex: 1, fontSize: 14, lineHeight: '18px', color: COLORS.secondary }}>
                                                {datatype_objects[item.data_type_id].name || "N/A"}
                                            </div>
                                            <SuggestedDatatypeLabel
                                                data_type_id={item.data_type_id}
                                                group_id={this.group_id}
                                                style={{ flex: 1 }}
                                                value={item.label}
                                                onChange={(value) => {
                                                    let _form_data = form_data;
                                                    let _data_type_labels = _form_data.data_type_labels || [];
                                                    _data_type_labels[item_index].label = value;
                                                    this.setState({ form_data: { ..._form_data, data_type_labels: _data_type_labels } })
                                                }}
                                                placeholder="Source Name"
                                            />
                                            {/* <Input
                                                style={{ flex: 1 }}
                                                value={item.label}
                                                onChange={(e) => {
                                                    let _form_data = form_data;
                                                    let _data_type_labels = _form_data.data_type_labels || [];
                                                    _data_type_labels[item_index].label = e.target.value;

                                                    this.setState({ form_data: { ..._form_data, data_type_labels: _data_type_labels } })
                                                }}
                                                placeholder="Source Name"
                                            /> */}
                                        </div>

                                    })}

                                    <span className='input-label' style={{
                                        color: '#000',
                                        marginTop: 8, marginBottom: 8
                                    }}>Extra Info</span>
                                    <div className='json-editor-wrapper'>
                                        <Editor
                                            mode={Editor.modes.code}
                                            value={form_data.extra_info || {}}
                                            onChange={(value) => {
                                                console.log("change value is", value);

                                                this.stateUpdater({
                                                    stateKey: 'form_data',
                                                    valueKey: 'extra_info',
                                                    value: value
                                                })
                                            }}
                                            className='small-json-editor'
                                            search={false}
                                            navigationBar={false}
                                            statusBar={false}
                                            ace={ace}
                                            // theme="ace/theme/github"
                                        /></div>
                    



                                </div>

                            </Modal>

                            <Spin spinning={!!(list_sourcegroup_resp.fetching || delete_sourcegroup_resp.fetching)}>
                                <Row >
                                    {
                                        rowsData.map((item, index) => {
                                            return <Col {...resp_card}>
                                                <SourceGroupItem
                                                    key={`${index}-`}
                                                    data={item}
                                                    datatypes={datatype_objects}
                                                    onEditPressed={(id, data) => {
                                                        let ref = data.__references__ || {};
                                                        let _labels = ref.labels || [];
                                                        let labels_key = lodash.map(_labels, 'label_id');
                                                        let data_type_labels = data.data_type_labels || [];
                                                        let data_type_labels_obj = lodash.keyBy(data_type_labels, 'data_type_id');
                                                        console.log("obj is", data_type_labels_obj);
                                                        let new_data_type_labels = Object.keys(datatype_objects).map((key) => {
                                                            return {
                                                                "data_type_id": key, "label": (data_type_labels_obj[key] && data_type_labels_obj[key].label) || null
                                                            }
                                                        });

                                                        this.setState({
                                                            edit_id: id,
                                                            form_data: {
                                                                ...data,
                                                                data_type_labels: new_data_type_labels,
                                                                labels: labels_key
                                                            },
                                                            form_visibility: true
                                                        })
                                                    }}
                                                    onDeletePressed={(id) => {
                                                        this.delete_sourcegroup.forId(id).execute()
                                                    }}
                                                />
                                            </Col>
                                        })
                                    }
                                    {((!list_sourcegroup_resp.fetching) && rowsData.length == 0) ? <Col span={24}>
                                        <Empty />
                                    </Col> : null}
                                </Row>
                                {rowsData.length > 0 ? <Row style={{
                                    paddingBottom: 16, paddingTop: 16
                                }} justify='end'>
                                    <Pagination
                                        size='small'
                                        onChange={(current, size) => {
                                            this.props.history.push({
                                                search: queryString.stringify({ ...this.state.filter_query, per_page: size, page: current })
                                            })
                                        }}
                                        defaultCurrent={1}
                                        current={rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0])}
                                        pageSize={(rowsMeta && rowsMeta.requested_count)}
                                        total={(rowsMeta && rowsMeta.total_count)}
                                        showTotal={(total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`}
                                    />
                                </Row> : null}
                            </Spin>

                        </ErrorWrapper>
                    </ErrorWrapper>
                </ErrorWrapper> </div>
        );
    }


    componentDidMount() {


        let new_filter_query = {};
        if (this.props.location && this.props.location.search) {
            const parsed = queryString.parse(this.props.location.search);
            new_filter_query = parsed;
        }
        this.setState({
            filter_query: {
                per_page: 100,
                page: 1,
                ...new_filter_query,
                group_id: this.group_id
            }
        }, () => {
            this.detail_group.forId(this.group_id).execute()
        })
    }

    componentWillReceiveProps(nextProps) {
        var oldgroup_id = this.props.match.params.group_id;
        var newgroup_id = nextProps.match.params.group_id;


        if (oldgroup_id !== newgroup_id || (
            this.props.location && (this.props.location.search !== nextProps.location.search)
        )) {
            this.group_id = newgroup_id;
            const parsed = queryString.parse(nextProps.location.search);
            this.setState({
                filter_query: {
                    per_page: 100,
                    page: 1,
                    ...parsed,
                    group_id: this.group_id
                },
            }, () => {
                if (oldgroup_id !== newgroup_id) {
                    this.setState({
                        loading: true
                    }, () => {
                        this.detail_group.forId(this.group_id).execute()
                    })
                } else {
                    this.list_sourcegroup.config({
                        params: {
                            ...this.state.filter_query
                        }
                    }).execute()
                }
            })

        }
    }


}

export default withDomains(GroupSourceList, "groups", "datatype");


const SourceGroupItem = ({
    data = {}, onEditPressed, onDeletePressed, datatypes = {}
}) => {
    let ref = data.__references__ || {};
    let labels = ref.labels || [];

    return <div className='default-card' style={{
        padding: 20
    }}>
        <div style={{
            flexDirection: 'row',
            justifyContent: 'space-between',
            display: 'flex',
            alignItems: 'center'
        }}>
            <span className='sub-heading-3 '>{data.name}</span>
            <div style={{
                display: 'flex',
                flexDirection: 'row', alignItems: 'center'
            }}><Button onClick={() => {
                typeof onEditPressed === 'function' && onEditPressed(data.id, data)
            }} style={{ padding: 0, marginRight: 8 }} title="Edit" type='link'>Edit</Button>
                <Popconfirm onConfirm={() => {
                    typeof onDeletePressed === 'function' && onDeletePressed(data.id, data)
                }} title="Are you sure you want to delete this source group?">
                    <DeleteForever className='hand-cursor' titleAccess="Delete" style={{
                        height: 17,
                        color: COLORS.secondary
                    }} />
                </Popconfirm>
            </div>

        </div>
        <div style={{
            paddingTop: 4, display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            flexWrap: 'wrap'
        }}>
            {labels.map((label_item) => {
                let label_ref = label_item.__references__ || {};
                let main_label = label_ref.label_id || {};
                return <Tag className='tag-orange' style={{ marginRight: 6, marginBottom: 4 }}>{main_label.label}</Tag>
            })}
        </div>
        <div style={{
            paddingTop: 20,
            display: 'flex',
            flexDirection: 'column'
        }}>
            {Array.isArray(data.data_type_labels) && data.data_type_labels.map((item, index) => {
                return <div key={`${index}--`} style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    paddingTop: 6, paddingBottom: 6
                }}>
                    <span className='sub-heading-4'>{(datatypes[item.data_type_id] && datatypes[item.data_type_id].name) || "N/A"}</span>
                    <span className='sub-heading-4'>{item.label}</span>
                </div>
            })}
        </div>
    </div>
}

class _SuggestedDatatypeLabel extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            suggested_data: [
            ]
        }
        this.list_suggestion = RESTExecutor.list().config({
            label: 'group_unlabelled_tags',
            params: {
                data_type_id: this.props.data_type_id,
                group_id: this.props.group_id
            }
        }).callbacks((success) => {
            let results = success.result.rows || [];
            this.setState({ suggested_data: results })

        }, () => {

        }).connect(props.domains.groups)
    }

    render() {
        const { suggested_data } = this.state;
        return <AutoComplete
            style={{ ...this.props.style }}
            // options={this.state.suggested_data}
            placeholder={this.props.placeholder}
            value={this.props.value}
            onChange={(value, option) => {
                console.log("on change ", value, option)
                typeof this.props.onChange === 'function' && this.props.onChange(value)
            }}
            onSelect={(value, option) => {
                console.log("on select ", value, option)
                typeof this.props.onChange === 'function' && this.props.onChange(value)
            }}
            filterOption={(inputValue, option) => {
                // console.log("filter option ",inputValue,option)
                return option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                // return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            }
        >
            {suggested_data.map((item) => {
                return <AutoComplete.Option key={item.label} value={item.label}>
                    {item.label}
                </AutoComplete.Option>
            })}
        </AutoComplete>
    }

    componentDidMount() {
        this.list_suggestion.execute()
    }
}

const SuggestedDatatypeLabel = withDomains(_SuggestedDatatypeLabel, "groups");
